import { render, staticRenderFns } from "./kEditor.vue?vue&type=template&id=4239eee9"
import script from "./kEditor.vue?vue&type=script&lang=js"
export * from "./kEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports